import { createGlobalStyle } from 'styled-components';

import Gothic from '@/assets/fonts/gothic.ttf';
import PixeloidSans from '@/assets/fonts/pixeloid-sans.ttf';
import Background from '@/assets/icons/cover-images/you-101.png';

const VariationsStyles = createGlobalStyle`
  @font-face {
      font-family: 'PixeloidSans';
      src: url(${PixeloidSans});
    }  
    
    @font-face {
      font-family: 'Gothic';
      src: url(${Gothic});
    }  
  
  .generated-images-holder-var30 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder-var30 {
    width: 100%;
    display: flex;
    position: relative;
    height: 630px;
    background: url(${Background}) no-repeat center center;
  }
  
  .right-text-var30 {
    text-align: center;
    color: #000;
    display: flex;
    font-weight: 400;
    align-items: center;
    justify-content: center;
    line-height: 1.2;
    position: absolute;
    bottom: 71px;
    right: 71px;
    height: 337px;
    width: 1058px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Gothic;
  }
  
  .heading-holder-var30 {
    font-size: 45px;
    font-family: PixeloidSans;
    color: #000;
    text-transform: uppercase;
    position: absolute;
    top: 163px;
    left: 0;
    width: 100%;
    text-align: center;
  }
`;

export default VariationsStyles;
